import { render, staticRenderFns } from "./courseJxcs.vue?vue&type=template&id=65ff28b6&scoped=true&"
import script from "./courseJxcs.vue?vue&type=script&lang=js&"
export * from "./courseJxcs.vue?vue&type=script&lang=js&"
import style0 from "./courseJxcs.vue?vue&type=style&index=0&id=65ff28b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff28b6",
  null
  
)

export default component.exports